<template>
  <PlanSegmentedControl
    v-if="isShown"
    :segments="segments"
    :styles="segmentStyles"
    data-test="plan-interval-switch"
    @select="selectInterval"
  />
</template>

<script>
import MonthlyText from "%/dynamic-component-editor/options/monthly-text";
import AnnualText from "%/dynamic-component-editor/options/annual-text";
import ShowAnnualSaving from "%/dynamic-component-editor/options/show-annual-saving";
import PlanSegmentedControl from "%/dynamic-component-editor/standard-components/plan-sheet/PlanSegmentedControl.vue";
import { PlanSegmentedControlMixin } from "%/dynamic-component-editor/standard-components/plan-sheet/plan-segmented-control-mixin";
import {
  INTERVALS,
  computeAnnualSavingPercent,
  hasSwitchableIntervals,
} from "%/dynamic-component-editor/standard-components/plan-sheet/plan-sheet-state";

// Monthly / annual switch for the enclosing Plan Sheet; hidden when no tier sells both.
export default {
  name: "PlanIntervalSwitch",
  components: { PlanSegmentedControl },
  mixins: [PlanSegmentedControlMixin],
  elementPanelSettings: {
    displayName: "Plan Interval Switch",
    displayIcon: "button",
    elementType: "element",
    tags: ["payments", "monthly", "annual", "interval", "toggle"],
  },
  options: [
    MonthlyText,
    AnnualText,
    ShowAnnualSaving,
  ],
  computed: {
    isShown() {
      if (this.editMode) {
        return true;
      }
      return Boolean(this.planSheet) && hasSwitchableIntervals(this.planSheet.plans);
    },
    activeInterval() {
      return this.planSheet?.interval ?? INTERVALS.MONTHLY;
    },
    annualSaving() {
      if (!this.planSheet || !this.getOptionValue(ShowAnnualSaving)) {
        return 0;
      }
      return computeAnnualSavingPercent(this.planSheet.plans, this.planSheet.selectedPlan);
    },
    segments() {
      return [
        {
          key: INTERVALS.MONTHLY,
          label: this.getOptionValue(MonthlyText),
          selected: this.activeInterval === INTERVALS.MONTHLY,
        },
        {
          key: INTERVALS.ANNUALLY,
          label: this.getOptionValue(AnnualText),
          selected: this.activeInterval === INTERVALS.ANNUALLY,
          badge: this.annualSaving > 0 ? `-${this.annualSaving}%` : "",
        },
      ];
    },
  },
  methods: {
    selectInterval(interval) {
      this.planSheet?.setInterval(interval);
    },
  },
};
</script>
